module.exports = __webpack_public_path__ + "img/take_a_survey.30e6baf9.svg";